
<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <app-side-nav></app-side-nav>
    <div class="layout-page">
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <div class="card">

            <!-- Back Button -->
            <div>
              <button type="button" class="btn btn" (click)="goBack()" style="color: blue;">
                <img src="assets/img/icons/back.png" alt="Back" style="width: 16px; height: 16px; margin-right: 5px; color: blue;">
                Back
              </button>
            </div>

            <!-- Card Header with Study Data and Add Subjects Button -->
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center w-100">
                <h5>Study Data / {{ studyName }}</h5>
                <button *ngIf="canAddDeleteSubjects" class="btn btn-success" type="button" (click)="onAddSubjectClick()">+ ADD SUBJECTS</button>
              </div>
            </div>

            <!-- Form Body -->


            <!-- <div class="card-body scrollable-card-body"> -->

              <!-- <div class="card-body"> -->


                <div class="card-body scrollable-card-body">
                  <div class="horizontal-scroll-container">


              <form [formGroup]="studyForm" (ngSubmit)="onSubmit()">
                <div formArrayName="visibleSubjects">
                  <div *ngFor="let subjectGroup of visibleSubjects.controls; let i = index" [formGroupName]="i" class="mb-3">
                    
                    <!-- Row for Labels -->
                    <div *ngIf="i === 0" class="row">
                      <div class="col-lg-2">
                        <!-- <p   class="fw-bold">Subject Name</p> -->

                        <p class="fw-bold">Subject ID</p>

                      </div>
                      <div class="col-lg-10 d-flex justify-content-around" formArrayName="visits">
                        <!-- <div *ngFor="let visit of subjectGroup.get('visits').controls; let j = index" [formGroupName]="j">
                          <label for="visit_{{ i }}_{{ j }}" class="fw-bold form-label">{{ getVisitLabel(j) }}</label>
                        </div> -->


                        <div *ngFor="let visit of subjectGroup.get('visits').controls; let j = index" class="visit-label">
                          <p class="fw-bold">
                            <span *ngIf="j === 0">Screening Visit(B{{ bufferValues[j] }})</span>
                            <span *ngIf="j === 1">Randomization Visit(F:{{ frequencies[j] }}, B: {{ bufferValues[j] }})</span>
                            <span *ngIf="j > 1">Visit {{ j - 1 }} (F:{{ frequencies[j] }}, B: {{ bufferValues[j] }})</span>
                          </p>
                        </div>


                      </div>


                    </div>
       
                    <div class="row">
                      <div class="col-lg-2">

                        

                        <label *ngIf="i === 0" class="form-label">Add Subject ID</label>

                        <input type="text" class="form-control" formControlName="subjectName" placeholder="Add Subject Name" />
                      </div>
                      <div class="col-lg-10 d-flex justify-content-around" formArrayName="visits">
                        <div *ngFor="let visit of subjectGroup.get('visits').controls; let j = index" [formGroupName]="j">
                          <div  class="d-inline-block me-2" style="width: 120px;">
                            <label *ngIf="i === 0" class="form-label">Schedule Date</label>
                            <input formControlName="schedule_date" type="date" class="form-control  form-control-sm" (change)="onScheduleDateChange(i)" required>
                          </div>
                          <div class="d-inline-block me-2" style="width: 120px;">
                            <label *ngIf="i === 0" class="form-label">Attended Date</label>
                            <input formControlName="visited_date" type="date" class="form-control form-control-sm" 
                              [ngClass]="{
                                'text-bg-success': !visit.get('is_late')?.value && visit.get('visited_date')?.value,
                                'text-bg-danger': visit.get('is_late')?.value === true
                              }" (change)="onAttendedDateChange(i, j)" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            
                <!-- Submit and Remove Buttons -->
                <div class="button-container d-flex mt-3">
                  <button *ngIf="visibleSubjects.length > 0" type="submit" class="btn btn-primary mt-3">Submit Visits</button>
                  <button *ngIf="visibleSubjects.length > 0 && canAddDeleteSubjects" type="button" class="btn btn-primary mt-3" (click)="onRemoveSubjectClick()">Remove Subject</button>
                </div>
              </form>
            </div>


            <!-- chat gpt div ends -->
            </div>
            



          </div> <!-- End Card -->
        </div> <!-- End Container -->
      </div> <!-- End Content Wrapper -->
    </div> <!-- End Layout Page -->
  </div> <!-- End Layout Container -->
  <div class="layout-overlay layout-menu-toggle"></div>
</div> <!-- End Layout Wrapper -->
